import Odoo from "odoo-xmlrpc";
import { OdooConfig } from "../utilities/odoo-config";


export const ObtenerHijoCajaAdmin = async (id, date, data, callback) => {
    console.log("cajaAdmin", id, date, data);
    const dataUser = JSON.parse(data);
    console.log("cajaAdmin", dataUser.userObject.user);
    const config = await OdooConfig();
    let finish = false;
    const args = [[0,
        parseInt(id),
        date]]

    const params = {
        model: "bcan.webservice",
        method: "obtenerHijoCajasBcan",
    }

    setTimeout(() => {
        if (finish) {
            return;
        }
        alert("Tiempo limite excedidoo");
        callback(false, "");
        return;
    }, 30000);

    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: dataUser.userObject.database,
        username: dataUser.userObject.user,
        password: dataUser.userObject.password
    });
    console.log("el cliente  ", client);

    client.connect((err, response) => {
        console.log("client connect", err, response);
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log(" la respuesta caja admin", err, response)
                finish = true
                if (err) {
                    callback(err, false);
                    return false;
                }
                callback(true, response, id);
            });
        }
    });
}

export const ObtenerHijoCajaAdminFechas = async (id, fecha_inicio, write_date, fecha_fin, data, callback) => {
    
    const dataUser = JSON.parse(data);
    console.log("cajaAdmin", fecha_inicio, fecha_fin);
    const config = await OdooConfig();
    let finish = false;
    const args = [[
        0,
        parseInt(id),
        fecha_inicio,
        write_date,
        fecha_fin
    ]]

    const params = {
        model: "bcan.webservice",
        method: "obtenerHijoCajasBcan",
    }

    setTimeout(() => {
        if (finish) {
            return;
        }
        alert("Tiempo limite excedidoo");
        callback(false, "");
        return;
    }, 30000);

    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: dataUser.userObject.database,
        username: dataUser.userObject.user,
        password: dataUser.userObject.password
    });
    console.log("el cliente  ", client);

    client.connect((err, response) => {
        console.log("client connect", err, response);
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log(" la respuesta caja admin", err, response)
                finish = true
                if (err) {
                    callback(err, false);
                    return false;
                }
                callback(true, response, id);
            });
        }
    });
}

export const openBoxAll = async (id, data, callback) => {
    const config = await OdooConfig();
    const dataUser = JSON.parse(data);
    const args = [[
        0, { user_id: parseInt(id) }
    ]]
    const params = {
        model: "epii.caja.webservice",
        method: "abrirCajasMasivas",
    }

    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: dataUser.userObject.database,
        username: dataUser.userObject.user,
        password: dataUser.userObject.password
    });

    client.connect((err, response) => {
        console.log("la res", response, err);
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log("la res", response, err);
                if (err) {
                    callback(err, false);
                    return false;
                }
                callback(response, true);
            });
        }
    });
}

export const getDetailBox = async (fecha_inicio, fecha_fin, id, data, bandera, callback) => {
    const config = await OdooConfig();
    let idSend = bandera ? 'res_users_id' : 'id'
    let dataSend = {
        fecha_inicio: fecha_inicio,
        fecha_fin: fecha_fin,
        [idSend]: parseInt(id)
    };
    const dataUser = JSON.parse(data);
    let finish = false;
    const args = [[
        0,
        dataSend
    ]]
    const params = {
        model: "bcan.webservice",
        method: "obtenerDetalleCaja"
    }

    setTimeout(() => {
        if (finish) {
            return;
        }
        alert("Tiempo limite excedido");
        callback(false, "");
        return;
    }, 30000);

    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: dataUser.userObject.database,
        username: dataUser.userObject.user,
        password: dataUser.userObject.password
    });
    console.log(client);
    console.log(args);

    client.connect((err, response) => {
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log(response);
                finish = true
                if (err) {
                    callback(err, false);
                    return false;
                }
                callback(response.caja_detalles, true);
            });
        }
    });
}


export const createTransaction = async (data, dataSend, callback) => {
    const config = await OdooConfig();
    const dataUser = JSON.parse(data);
    console.log("cajaAdmin", dataUser.userObject);
    const args = [[[], dataSend]]
    const params = {
        model: "epii.caja.webservice",
        method: "subirTransaccion",
    }

    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: dataUser.userObject.database,
        username: dataUser.userObject.user,
        password: dataUser.userObject.password
    });

    client.connect((err, response) => {
        console.log("la res", response, err);
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log("la res", response, err);
                if (err) {
                    callback(err, false);
                    return false;
                }
                callback(response, true);
            });
        }
    });
}

export const CloseBox = async (data, dataSend, callback) => {
    const config = await OdooConfig();
    const dataUser = JSON.parse(data);
    console.log("cajaAdmin", dataUser.userObject);
    const args = [[[], { id: dataSend }]]
    const params = {
        model: "epii.caja.webservice",
        method: "cerrarCaja",
    }

    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: dataUser.userObject.database,
        username: dataUser.userObject.user,
        password: dataUser.userObject.password
    });

    client.connect((err, response) => {
        console.log("la res", response, err);
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log("la res", response, err);
                if (err) {
                    callback(err, false);
                    return false;
                }
                callback(response, true);
            });
        }
    });
}

export const OpenBox = async (data, dataSend, callback) => {
    const config = await OdooConfig();
    const dataUser = JSON.parse(data);
    console.log("cajaAdmin", dataUser.userObject);
    const args = [[[], { id: dataSend }]]
    const params = {
        model: "epii.caja.webservice",
        method: "abrirCaja",
    }

    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: dataUser.userObject.database,
        username: dataUser.userObject.user,
        password: dataUser.userObject.password
    });

    client.connect((err, response) => {
        console.log("la res", response, err);
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log("la res", response, err);
                if (err) {
                    callback(err, false);
                    return false;
                }
                callback(response, true);
            });
        }
    });
}

export const GetDefaulters = async (data, id, callback) => {
    //ES para castigar la cartera
    const config = await OdooConfig();
    const dataUser = JSON.parse(data);

    const args = [[
        0,
        { res_users_id: parseInt(id) }
    ]]
    const params = {
        model: "bcan.webservice",
        method: "obtenerMorosos"
    }
    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: dataUser.userObject.database,
        username: dataUser.userObject.user,
        password: dataUser.userObject.password
    });

    client.connect((err, response) => {
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log(err, response);
                if (err) {
                    callback(err, false);
                    return false;
                }
                callback(response, true);
            });
        }
    });
}

export const InactiveUser = async (dataSend, data, callback) => {
    const config = await OdooConfig();
    const dataUser = JSON.parse(data);

    const args = [[
        0,
        dataSend
    ]]
    const params = {
        model: "bcan.webservice",
        method: "castigarCartera",
    }
    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: dataUser.userObject.database,
        username: dataUser.userObject.user,
        password: dataUser.userObject.password
    });

    client.connect((err, response) => {
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                if (err) {
                    callback(err, false);
                    return false;
                }
                callback(true, response);
            });
        }
    });
}


export const InactiveUsuario = async (dataSend, data, callback) => {
    const config = await OdooConfig();
    const dataUser = JSON.parse(data);

    const args = [[
        0,
        dataSend
    ]]
    const params = {
        model: "epii.caja.webservice",
        method: "inactivarUsuarioCartera",
    }
    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: dataUser.userObject.database,
        username: dataUser.userObject.user,
        password: dataUser.userObject.password
    });
    client.connect((err, response) => {
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                if (err) {
                    callback(err, false);
                    return false;
                }
                callback(true, response);
            });
        }
    });
}

//ES para activar el usuario
export const ActiveUser = async (dataSend, data, callback) => {
    const config = await OdooConfig();
    const dataUser = JSON.parse(data);

    const args = [[
        0,
        dataSend
    ]]
    const params = {
        model: "epii.caja.webservice",
        method: "activarUsuarioCartera",
    }
    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: dataUser.userObject.database,
        username: dataUser.userObject.user,
        password: dataUser.userObject.password
    });
    client.connect((err, response) => {
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                if (err) {
                    callback(err, false);
                    return false;
                }
                callback(true, response);
            });
        }
    });
}

//Es para editar el usuario 
export const registUser = async (dataSend, data, callback) => {

    const config = await OdooConfig();
    const dataUser = JSON.parse(data);

    const args = [[
        0,
        [dataSend]
    ]]
    console.log("args que se envia", dataSend);

    const params = {
        model: 'epii.caja.webservice',
        method: "subirClientes",
    }
    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: dataUser.userObject.database,
        username: dataUser.userObject.user,
        password: dataUser.userObject.password
    });

    client.connect((err, response) => {
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log(err, response);
                if (err) {
                    if (err.code === 100) {
                        alert("Error", "La sesión a expirado, es necesario volver a loguearse.")

                        return callback("close", false);
                    } else {
                        console.log("El Error 2 es: ", JSON.stringify(err));

                        return callback(err, false);
                    }

                } else {
                    callback(true, response);
                }

            });
        }
    });
}


export const ObtenerCarteraVendedor = async (data, callback) => {
    const config = await OdooConfig();
    const dataUser = JSON.parse(data);

    const args = [[{}]]
    const params = {
        model: "bcan.webservice",
        method: "obtenercarteravendedor",
    }
    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: dataUser.userObject.database,
        username: dataUser.userObject.user,
        password: dataUser.userObject.password
    });
    client.connect((err, response) => {
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                if (err) {
                    callback(false, err);
                    return false;
                }
                callback(true, response);
            });
        }
    });
  }

  export const consumir_refacil_pse = async (DataSend, data,callback) => {
    const config = await OdooConfig();
    

    const args = [[[],DataSend]];
    const params = {
        model: 'refacil.webservice',
        method: 'consumir_refacil_pse',
    }
    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: config.database,
        username: data.user,
        password: data.password
    });
    client.connect((err, response) => {
        if (err) {
            return callback(response, false)
        } else {
            console.log("datasend",DataSend)
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log("reespuesta",response,err);
                
                if (err) {
                    callback(false, err);
                    return false;
                }
                callback(true, response);
            });
        }
    });
  };

  export const create_student = async (DataSend, data, callback) => {
    const config = await OdooConfig();
    console.log("respuesta envio", DataSend);

    const args = [[[], DataSend]];
    const params = {
        model: 'club.user.webservice',
        method: 'create_student',
    };
    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: config.database,
        username: data.user,
        password: data.password
    });

    client.connect((err, response) => {
        if (err) {
            return callback(false, { message: "Error de conexión con el servidor" });
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log("respuesta", response, err);

                if (err) {
                    // Capturamos el error específico del servidor
                    const errorMessage = err.faultString || "Error al crear el deportista";
                    return callback(false, { message: errorMessage });
                }
                callback(true, response);
            });
        }
    });
};

  export const update_student = async (DataSend, data,callback) => {
    const config = await OdooConfig();
    

    const args = [[[],DataSend]];
    const params = {
        model: 'club.user.webservice',
        method: 'update_student',
    }
    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: config.database,
        username: data.user,
        password: data.password
    });
    client.connect((err, response) => {
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log("reespuesta",response,err);
                
                if (err) {
                    callback(false, err);
                    return false;
                }
                callback(true, response);
            });
        }
    });
  };

  export const unlink_student = async (DataSend, data,callback) => {
    const config = await OdooConfig();
    

    const args = [[[],DataSend]];
    const params = {
        model: 'club.user.webservice',
        method: 'unlink_student',
    }
    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: config.database,
        username: data.user,
        password: data.password
    });
    client.connect((err, response) => {
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log("reespuesta",response,err);
                
                if (err) {
                    callback(false, err);
                    return false;
                }
                callback(true, response);
            });
        }
    });
  };


  export const get_account_moves = async (DataSend, data,callback) => {
    const config = await OdooConfig();
    

    const args = [[[],DataSend]];
    const params = {
        model: 'club.user.webservice',
        method: 'get_account_moves',
    }
    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: config.database,
        username: data.user,
        password: data.password
    });
    client.connect((err, response) => {
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log("reespuesta",response,err);
                
                if (err) {
                    callback(false, err);
                    return false;
                }
                callback(true, response);
            });
        }
    });
  };

  export const get_attendance = async (DataSend, data,callback) => {
    const config = await OdooConfig();
    

    const args = [[[],DataSend]];
    const params = {
        model: 'club.user.webservice',
        method: 'get_attendance',
    }
    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: config.database,
        username: data.user,
        password: data.password
    });
    
    client.connect((err, response) => {
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log("reespuesta",response,err);
                
                if (err) {
                    callback(false, err);
                    return false;
                }
                callback(true, response);
            });
        }
    });
  };


  export const get_product = async ( data,callback) => {
    const config = await OdooConfig();
    console.log('dataUser...',data);

    const args = [[[]]];
    const params = {
        model: 'club.user.webservice',
        method: 'get_product',
    }
    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: config.database,
        username: data.user,
        password: data.password
    });
    
    client.connect((err, response) => {
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log("reespuesta_product",response,err);
                
                if (err) {
                    callback(false, err);
                    return false;
                }
                callback(true, response);
            });
        }
    });
  };

  export const get_groups = async ( data,callback) => {
    const config = await OdooConfig();
    console.log('dataUser...',data);

    const args = [[[]]];
    const params = {
        model: 'club.user.webservice',
        method: 'get_groups',
    }
    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: config.database,
        username: data.user,
        password: data.password
    });
    
    client.connect((err, response) => {
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log("reespuesta_groups",response,err);
                
                if (err) {
                    callback(false, err);
                    return false;
                }
                callback(true, response);
            });
        }
    });
  };

  export const get_trainer = async ( data,callback) => {
    const config = await OdooConfig();
    console.log('dataUser...',data);

    const args = [[[]]];
    const params = {
        model: 'club.user.webservice',
        method: 'get_trainer',
    }
    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: config.database,
        username: data.user,
        password: data.password
    });
    
    client.connect((err, response) => {
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log("reespuesta_groups",response,err);
                
                if (err) {
                    callback(false, err);
                    return false;
                }
                callback(true, response);
            });
        }
    });
  };

  export const create_product = async (DataSend, data,callback) => {
    const config = await OdooConfig();
    

    const args = [[[],DataSend]];
    const params = {
        model: 'club.user.webservice',
        method: 'create_product',
    }
    const client = new Odoo({
        url: config.host,
        port: config.port,
        db: config.database,
        username: data.user,
        password: data.password
    });
    client.connect((err, response) => {
        if (err) {
            return callback(response, false)
        } else {
            client.execute_kw(params.model, params.method, args, async (err, response) => {
                console.log("reespuesta",response,err);
                
                if (err) {
                    callback(false, err);
                    return false;
                }
                callback(true, response);
            });
        }
    });
  };
